module.exports = __webpack_public_path__ + "curacao.svg?cdd11806d2a3da20fcec8e2dd0b6598f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/curacao.svg
// module id = 145
// module chunks = 10